module.exports = __webpack_public_path__ + "static/media/s_big_01.26fd9891.png";